define([
	"dojo/_base/declare",
	"csi/def/Action",
	"Apparel/ColorwayMixin"
], function(declare,Action,ColorwayMixin) {

	return declare([Action, ColorwayMixin], {
		hasAccess: function(/*csi.def.Context*/ctx) {
			// summary: determine if have access to add colorway color to theme
			return this.inherited(arguments) && this._isThemeChangeable(ctx) && !this._isColorInTheme(ctx, true);
		}
	});
});